import { DATA_UPDATED_FILL_COLOR, DATA_UPDATED_FONT_COLOR } from "../../../globalValues";
import { ENABLED_BUTTON_TO_UPDATE_TEXT, UPDATE_BUTTON_IDX } from "../../constants";

export const pendingToUploadButtonStyles = (table: Excel.Table, row: number) => {
  const actionButton = table.columns.getItemAt(UPDATE_BUTTON_IDX).getRange().getCell(row, 0);
  const buttonsRange = table.columns.getItemAt(UPDATE_BUTTON_IDX).getRange();

  actionButton.format.fill.color = DATA_UPDATED_FILL_COLOR;
  actionButton.format.font.color = DATA_UPDATED_FONT_COLOR;
  actionButton.values = [[ENABLED_BUTTON_TO_UPDATE_TEXT]];

  buttonsRange.format.autofitColumns();
  buttonsRange.format.horizontalAlignment = Excel.HorizontalAlignment.center;
};
